const EnumReviewPercent = {
  TOP10: "TOP10",
  TOP25: "TOP25",
  TOP50: "TOP50",
  LOW50: "LOW50",
  LOW25: "LOW25",
  NA: "NA",
};

export default EnumReviewPercent;
